import { CognitoUser } from 'amazon-cognito-identity-js'
import cognitoUserPool from './cognitoUserPool'

const cognitoUser = (username) => {
  const userData = {
    Username: username,
    Pool: cognitoUserPool
  }
  return new CognitoUser(userData)
}

export default cognitoUser



// WEBPACK FOOTER //
// ./src/cognito-objects/cognitoUser.js